"use strict";

angular.module("internal.exams").controller("InternalExamSessionCorrespondences", [
    "$scope",
    "$stateParams",
    "EXSessions",
    function ($scope, $stateParams, EXSessions) {
        $scope.loading = true;
        $scope.SkillCategoriesFilter = [];
        $scope.Correspondences = [];
        $scope.examSessionID = $stateParams.examSessionID;

        EXSessions.getcorrespondence($stateParams.examSessionID).then(function (correspondences) {
            $scope.correspondences = correspondences.records;
            $scope.correspondences.forEach(function (correspondence) {
                correspondence.examSessionID = $scope.examSessionID;
                correspondence.modifiedOn = correspondence.modifiedOn.revertTimeZone();
            })
            $scope.loading = false;
        });

        EXSessions.getsessionsummary($stateParams.examSessionID).then(function (sessionSummary) {
            $scope.sessionSummary = sessionSummary;
        });

        $scope.columns = [
            {
                label: "Subject",
                field: "subject",
                link: {
                    state: "internal.exams.session.correspondence",
                    params: [
                        {
                            name: "correspondenceID",
                            field: "id"
                        },
                        {
                            name: "examSessionID",
                            field: "examSessionID"
                        }
                    ]
                }
            },
            {
                label: "To Address",
                field: "toAddress"
            },
            {
                label: "Template",
                field: "mergeTemplateName"
            },
            {
                label: "Sent On",
                field: "modifiedOn",
                type: "datetime"
            },
            {
                label: "Modified By",
                field: "modifiedByUserSummary.fullName"
            }
        ];
    }
]);
